import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { Response } from 'app/modules/well-integrity-planning/model';
import { composeUrl } from 'app/core/shared/helper/url.helper';

@Injectable({ providedIn: 'root' })
export class PmDashboardService {
    private _FieldSummary: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    get fieldSummary$(): Observable<any> {
        return this._FieldSummary.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getPmFieldSummary(params: any): Observable<Response<any>> {
        const url = composeUrl(`v1/WIM/DashboardWIM/pm/fields/summary`, params);

        let response = this._httpClient.get<Response<any>>(url).pipe(take(1));

        response.subscribe((res) => {
            this._FieldSummary.next(res);
        });

        return response;
    }

    getPmStringSummary(params: any): Observable<Response<any>> {
        const url = composeUrl(
            `v1/WIM/DashboardWIM/pm/strings/summary`,
            params
        );

        let response = this._httpClient.get<Response<any>>(url).pipe(take(1));

        return response;
    }

    getPmFieldSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWIM/pm/fields/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }

    getPmStringSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWIM/pm/strings/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }
}
